import React from 'react';
import { C, font, serif } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const grad = `linear-gradient(90deg, ${C.turquesa} 0%, ${C.mango} 55%, ${C.coral} 100%)`;

const CARDS = [
  { name: 'Taller artesanal',       sub: 'Maquinaria nueva',        color: C.mango,    pct: 85,  raised: '$38,200', goal: '$45,000', likes: 312, followers: '1.2 k', donors: 41, left: '2%',  top: '3%',    rot: -5, dur: 8   },
  { name: 'Cafetería de barrio',     sub: 'Segunda sucursal',        color: C.turquesa, pct: 40,  raised: '$24,000', goal: '$60,000', likes: 148, followers: '860',   donors: 19, left: '3%',  bottom: '4%', rot: 4,  dur: 9.5 },
  { name: 'Estudio de diseño',       sub: 'Equipo de producción',    color: C.coral,    pct: 62,  raised: '$31,000', goal: '$50,000', likes: 203, followers: '2.1 k', donors: 27, right: '2%', top: '3%',    rot: 5,  dur: 8.5 },
  { name: 'Cabañas ecoturísticas',   sub: 'Terraza y cocina nueva',  color: C.turquesa, pct: 100, raised: '$80,000', goal: '$80,000', likes: 540, followers: '3.4 k', donors: 96, right: '3%', bottom: '4%', rot: -4, dur: 7.5, funded: true },
];

export default function CrowdfundingPreview({ isMobile }) {
  const reveal = useScrollReveal();

  const [showFloat, setShowFloat] = React.useState(() => typeof window !== 'undefined' && window.innerWidth >= 900);
  React.useEffect(() => {
    const fn = () => setShowFloat(window.innerWidth >= 900);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  const isMob = isMobile || !showFloat;

  return (
    <section
      id="crowdfunding"
      ref={reveal.ref}
      style={{
        overflow: 'hidden',
        padding: isMob ? '2.5rem 0' : '48px 0 72px',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      <div style={{
        position: 'relative', maxWidth: 1280, width: '100%', margin: '0 auto',
        height: isMob ? 'auto' : 760,
        ...(isMob ? { display: 'flex', flexDirection: 'column', gap: 16, padding: '0 16px' } : {}),
      }}>
        {/* ── Center content ── */}
        <div style={{
          ...(isMob
            ? { textAlign: 'center', marginBottom: 16 }
            : { position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', textAlign: 'center', zIndex: 5, width: 560 }
          ),
        }}>
          <span style={{
            display: 'inline-block', fontSize: 11, letterSpacing: 3, fontWeight: 800,
            padding: '8px 14px', borderRadius: 999,
            background: C.coral, color: '#2a0b0b',
          }}>PRÓXIMAMENTE</span>

          <p style={{
            fontSize: 12, letterSpacing: 3, fontWeight: 700,
            textTransform: 'uppercase', color: C.mango, margin: '12px 0 8px',
          }}>Lo realizas · el premio del árbol</p>

          <h2 style={{
            fontFamily: serif,
            fontSize: isMob ? 38 : 'clamp(48px, 6.5vw, 88px)',
            lineHeight: 1, margin: '0 0 12px',
          }}>
            <em style={{
              background: grad, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text', fontStyle: 'italic',
            }}>Crowdfunding</em>
          </h2>

          <p style={{
            fontSize: isMob ? 14 : 17, color: 'rgba(255,255,255,0.55)',
            maxWidth: 480, margin: '0 auto 20px', lineHeight: 1.6,
          }}>
            Al vencer el Mundo 07 tu carta se habilita para recibir donaciones. Tú mueves la
            campaña con tu gente; T&D pone la plataforma y la transparencia.
          </p>

          {/* Video thumbnail */}
          <div
            style={{
              width: isMob ? '100%' : 420, margin: '0 auto',
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${C.border}`,
              borderRadius: 16, overflow: 'hidden', textAlign: 'left',
              boxShadow: '0 30px 70px rgba(0,0,0,0.5)',
              transition: 'transform 0.4s cubic-bezier(.16,1,.3,1), box-shadow 0.4s',
              cursor: 'pointer', position: 'relative', zIndex: 6,
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 36px 80px rgba(253,190,2,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 30px 70px rgba(0,0,0,0.5)'; }}
          >
            <div style={{
              position: 'relative', height: isMob ? 180 : 236,
              background: 'linear-gradient(160deg, #0f2e2c, #1fa89c 60%, #c98a2a)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 50%, rgba(11,11,16,0.7))' }} />
              <div style={{
                position: 'relative', zIndex: 1,
                width: 64, height: 64, borderRadius: '50%',
                background: C.mango, color: '#2a1a00',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, paddingLeft: 4,
                boxShadow: '0 10px 30px rgba(253,190,2,0.5)',
              }}>▶</div>
              <span style={{
                position: 'absolute', right: 10, bottom: 10, zIndex: 1,
                fontSize: 11, fontWeight: 700, padding: '3px 6px',
                background: 'rgba(0,0,0,0.75)', borderRadius: 4, color: '#fff',
              }}>4:32</span>
              <span style={{
                position: 'absolute', left: 10, top: 10, zIndex: 1,
                fontSize: 10, letterSpacing: 1.5, fontWeight: 800,
                padding: '4px 8px', background: C.coral, color: '#2a0b0b', borderRadius: 4,
              }}>HISTORIA REAL</span>
            </div>
            <div style={{ padding: '12px 14px' }}>
              <strong style={{ display: 'block', fontSize: 14, color: '#fff' }}>Cómo obtener tu primer fondeo</strong>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>Guía de Thinker & Doer · 2.4 k vistas · hace 3 días</span>
            </div>
          </div>
        </div>

        {/* ── Floating .fcf-style cards ── */}
        {CARDS.map((c, i) => {
          const pos = {};
          if (c.left) pos.left = c.left;
          if (c.right) pos.right = c.right;
          if (c.top) pos.top = c.top;
          if (c.bottom) pos.bottom = c.bottom;

          const barColor = c.funded ? C.mango : c.color;

          return (
            <article
              key={i}
              className="td-cf-card"
              style={{
                '--r': `${c.rot}deg`, '--dur': `${c.dur}s`, '--delay': `${-(i * 1.1)}s`,
                '--glow': c.color,
                ...(isMob
                  ? { width: '100%' }
                  : { position: 'absolute', width: 250, zIndex: 1, ...pos }
                ),
                background: 'rgba(255,255,255,0.04)',
                border: `1px solid ${C.border}`,
                borderRadius: 18, overflow: 'hidden',
                boxShadow: '0 20px 50px rgba(0,0,0,0.45)',
                transition: 'box-shadow 0.4s, border-color 0.3s',
              }}
            >
              {/* Color block header */}
              <div style={{
                position: 'relative', height: 120,
                background: `linear-gradient(160deg, rgba(${hexRgb(c.color)},0.3), rgba(${hexRgb(c.color)},0.08))`,
              }}>
                {c.funded && (
                  <span style={{
                    position: 'absolute', top: 10, left: 10, zIndex: 1,
                    fontSize: 9, letterSpacing: 1, fontWeight: 800,
                    padding: '4px 8px', borderRadius: 999,
                    background: 'rgba(11,11,16,0.75)',
                    border: `1px solid ${C.mango}`, color: C.mango,
                  }}>✓ FONDEADO</span>
                )}
              </div>

              {/* Meta */}
              <div style={{ padding: 12 }}>
                <strong style={{ display: 'block', fontSize: 13, color: '#fff' }}>{c.name}</strong>
                <span style={{ display: 'block', fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 8 }}>{c.sub}</span>

                {/* Funding bar */}
                <div style={{ height: 7, borderRadius: 4, background: 'rgba(255,255,255,0.06)' }}>
                  <div style={{ width: `${c.pct}%`, height: '100%', borderRadius: 4, background: barColor }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 6 }}>
                  <span>{c.raised} de {c.goal}</span>
                  <em style={{ fontStyle: 'normal', fontWeight: 800, color: barColor }}>{c.pct}%</em>
                </div>
                <div style={{ marginTop: 8, fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
                  ♥ {c.likes} · {c.followers} seguidores · {c.donors} donantes
                </div>
              </div>
            </article>
          );
        })}
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center', marginTop: 20, padding: '0 24px' }}>
        <button style={{
          background: 'transparent',
          border: `1px solid ${C.mango}`, color: C.mango,
          borderRadius: 999, padding: '0 22px', height: 46, fontWeight: 700,
          fontSize: 15, cursor: 'pointer', fontFamily: font,
        }}>Ver cómo funcionará el crowdfunding</button>
      </div>

      <style>{`
        @keyframes tdCfFloat {
          0%,100% { transform: rotate(var(--r)) translateY(0); }
          50%     { transform: rotate(calc(var(--r) * -0.4)) translateY(-14px); }
        }
        .td-cf-card {
          animation: tdCfFloat var(--dur) ease-in-out infinite;
          animation-delay: var(--delay);
          transition: box-shadow 0.4s, border-color 0.3s, transform 0.4s cubic-bezier(.16,1,.3,1);
        }
        .td-cf-card:hover {
          animation-play-state: paused;
          transform: rotate(0deg) scale(1.05) !important;
          border-color: var(--glow) !important;
          box-shadow: 0 30px 70px color-mix(in srgb, var(--glow) 35%, transparent) !important;
          z-index: 4 !important;
        }
        @media (max-width:899px)  { .td-cf-card { animation: none !important; } }
        @media (prefers-reduced-motion:reduce) { .td-cf-card { animation: none !important; } }
      `}</style>
    </section>
  );
}

function hexRgb(hex) {
  const h = hex.replace('#', '');
  return `${parseInt(h.substring(0,2),16)},${parseInt(h.substring(2,4),16)},${parseInt(h.substring(4,6),16)}`;
}
